import { Link, List, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UploadDocumentType } from "../../../types";

import { DocumentUpload } from "./document-upload";
import { MESSAGES } from "./message-definitions";

export const SusaDocumentUpload = ({ includeHeader = false, error }: { includeHeader?: boolean; error?: string }) => {
  const intl = useIntl();
  return (
    <DocumentUpload
      documentType={UploadDocumentType.SUSA}
      supportedFileExtensions={[".xlsx"]}
      fileSizeLimitMB={50}
      header={includeHeader ? intl.formatMessage(MESSAGES.susaTitle) : undefined}
      error={error}
      description={
        <List type="bullet">
          <List.Item>
            <Text>{intl.formatMessage(MESSAGES.susaDescriptionPoint1)}</Text>
          </List.Item>
          <List.Item>
            <Text>
              {intl.formatMessage(MESSAGES.susaDescriptionPoint2, {
                link: (str: string) => (
                  <Link url="https://apps.datev.de/help-center/documents/9211678" external>
                    {str}
                  </Link>
                ),
              })}
            </Text>
          </List.Item>
        </List>
      }
    />
  );
};
